import React from "react";
import "./Footer.css";
import { IMAGES } from "../../config/supabaseImages";

const Footer = () => {
  const logoSrc =
    IMAGES?.logos?.logoBlanco ||
    IMAGES?.logos?.logoNegroSintesis ||
    IMAGES?.logos?.logoNegro ||
    "";

  const PLACEHOLDER_LOGO =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="120" viewBox="0 0 400 120"><rect width="100%" height="100%" fill="transparent"/><text x="50%" y="50%" fill="#fff" font-family="Arial, sans-serif" font-size="20" dominant-baseline="middle" text-anchor="middle">Sole Costilla</text></svg>`
    );

  const handleLogoError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = PLACEHOLDER_LOGO;
    e.currentTarget.alt = "Logo (fallback)";
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        {/* CONTACT */}
        <div className="site-footer__col site-footer__contact" aria-label="Contacto">
          <h4 className="site-footer__heading">Contacto</h4>
          <p className="site-footer__contact-link">
            <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden focusable="false">
              <path fill="currentColor" d="M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm0 2v.01L12 12l8-5.99V6H4zm16 2.24l-7.4 5.55a1 1 0 01-1.2 0L4 8.24V18h16V8.24z"/>
            </svg>
            scgroup@gmail.com
          </p>
          <a href="https://wa.me/3816818108" className="site-footer__contact-link">
            <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden focusable="false">
              <path fill="currentColor" d="M6.6 10.8c1.2 2.4 3.2 4.4 5.6 5.6l1.9-1.9c.2-.2.6-.3.9-.2 1 .3 2.1.5 3.2.5.5 0 .8.4.8.8V19c0 .5-.4.8-.8.8C10.6 19.8 4.2 13.4 4.2 5.8c0-.5.4-.8.8-.8h3.4c.5 0 .8.4.8.8 0 1.1.2 2.2.5 3.2.1.3 0 .7-.2.9l-1.9 1.9z"/>
            </svg>
            +54 3816818108
          </a>
          <p className="site-footer__contact-link">
            <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden focusable="false">
              <path fill="currentColor" d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5A2.5 2.5 0 1112 6.5a2.5 2.5 0 010 5z"/>
            </svg>
            San Miguel de Tucumán
          </p>
        </div>

        {/* NAV LINKS */}
        <nav className="site-footer__col" aria-label="Enlaces del sitio">
          <h4 className="site-footer__heading">Enlaces útiles</h4>
          <ul className="site-footer__list">
            <li><a href="/">Inicio</a></li>
            <li><a href="/faq">Preguntas frecuentes</a></li>
            <li><a href="/politicas">Políticas de Privacidad</a></li>
            <li><a href="/terminos">Términos y Condiciones</a></li>
          </ul>
        </nav>

        {/* BRAND / LOGO */}
        <div className="site-footer__brand">
          <div className="site-footer__logo-frame">
            <img
              className="site-footer__logo"
              src={logoSrc || PLACEHOLDER_LOGO}
              alt="Sole Costilla Group logo"
              onError={handleLogoError}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>
          &copy; {currentYear} Sole Costilla Group. Todos los derechos reservados. — Desarrollado por{" "}
          <a className="site-footer__dev-link" href="https://www.instagram.com/sc_software.tuc/" target="_blank" rel="noopener noreferrer">scsoftware</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;